import React from 'react';

export default function PrimaryOverlay({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <div className="absolute left-0 top-0 z-20 flex h-full w-full items-center justify-center rounded-lg bg-primary-900 bg-opacity-50 backdrop-blur-md backdrop-filter">
      {children}
    </div>
  );
}
